// extracted by mini-css-extract-plugin
export default {"intellect-card-shop":"index_intellect-card-shop__hlOJD"};